import React, { useState, useEffect } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import DOMPurify from 'dompurify';
import { logger } from '../utils/logger';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// Configuration: Choose between 'markdown' or 'html' format
const TERMS_FORMAT = 'markdown'; // Change to 'html' to use HTML format

function TermsAndConditions() {
    const [termsAndConditionsRef, isTermsAndConditionsVisible] = useScrollAnimation({ threshold: 0.15 });
    const [termsContent, setTermsContent] = useState('');
    
    useEffect(() => {
        const filePath = TERMS_FORMAT === 'markdown' ? '/terms-and-conditions.md' : '/terms-and-conditions.html';
        
        fetch(filePath)
            .then(response => response.text())
            .then(content => {
                if (TERMS_FORMAT === 'html') {
                    const sanitizedHtml = DOMPurify.sanitize(`<div>${content}</div>`);
                    setTermsContent(sanitizedHtml);
                } else {
                    // For markdown, we'll store the raw markdown content
                    setTermsContent(content);
                }
            })
            .catch((error) => {
                logger.error('Error fetching terms', error);
            });
    }, []);

    return (
        <div className="bg-[#f3f3f3] pb-4 pt-20 font-ui min-h-screen">
            <div
                ref={termsAndConditionsRef}
                className={`max-w-7xl mx-auto px-5 py-10 bg-white rounded-[20px] p-12 m-12 lg:p-16 shadow-sm transition-all duration-1000 ease-out transform ${isTermsAndConditionsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                    }`}
            >
                <div>
                    <div className="bg-white rounded-lg max-h-screen overflow-y-auto shadow-2xl w-full flex flex-col">
                        <div className="flex-1 overflow-y-auto p-6">
                            {TERMS_FORMAT === 'html' ? (
                                <div
                                    dangerouslySetInnerHTML={{ __html: termsContent }}
                                    className="prose prose-xs max-w-none font-sans text-xs"
                                />
                            ) : (
                                <ReactMarkdown
                                    remarkPlugins={[remarkGfm]}
                                    className="prose prose-xs max-w-none font-sans text-xs"
                                >
                                    {termsContent}
                                </ReactMarkdown>
                            )}
                        </div>
                    </div>
                </div>  
            </div>
        </div>
    );
}

export default TermsAndConditions;